import React from "react";
import styled from "styled-components";

import NavLink from "./NavLink";

const NavLinkList = ({ theme }) => {
  const logos_blk = [
    { icon: "git", href: "https://github.com/waddal" },
    { icon: "linkd", href: "https://www.linkedin.com/in/alan-waddell/" },
  ];

  const logos_wht = [
    { icon: "git", href: "https://github.com/waddal" },
    { icon: "linkd", href: "https://www.linkedin.com/in/alan-waddell/" },
  ];

  const logos = theme === "light" ? logos_blk : logos_wht;

  return (
    <StyledNavLinkList>
      {logos.map((item, index) => {
        return (
          <NavLink
            icon={item.icon}
            alt={`${item.icon}`}
            key={index}
            href={item.href}
          />
        );
      })}
    </StyledNavLinkList>
  );
};

export default NavLinkList;

const StyledNavLinkList = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
